{
	"transactionCardHeader": "Validează o tranzacție",
	"transactionCardDescriptionBold": "Vrei să validezi o tranzacție pentru orice proiect?",
	"transactionCardDescriptionRegular": "Dacă ai la îndemână un număr de tranzacție, îl poți introduce aici și valida tranzacția.",
	"showTransactionButton": "Afișează tranzacția",
	"transactionLabel": "Număr tranzacție",
	"errors": {
		"transactionIdRequired": "Numărul tranzacției este obligatoriu.",
		"transactionNotFound": "Tranzacția nu a fost găsită.",
		"transactionIdInvalid": "Număr de tranzacție invalid."
	}
}
